const announcementsEN = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} Unread Announcements",
            "empty": "No announcements",
            "newBadge": "New",
            "dismissAll": "Dismiss All",
        },
        "modal": {
            "defaultTitle": "Announcement",
        },
        "table": {
            "title": "Announcements",
            "column": {
                "title": "Title",
                "datePosted": "Date Posted",
                "dismissed": "Dismissed",
                "status": "Status",
                "action": "Action",
            },
            "status": {
                "read": "Read",
                "unread": "Unread",
            },
            "csv": {
                "statusRead": "Read",
                "statusUnread": "Unread",
                "dismissedYes": "Dismissed",
                "dismissedNo": "Not Dismissed",
            },
            "action": {
                "view": "View",
            },
            "button": {
                "exportCsv": "Export CSV",
            },
        },
    },
};

export default announcementsEN;
